import { useRef } from 'react'
import { Link, Form } from 'react-router'
import { Button } from '#app/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuTrigger,
	DropdownMenuPortal,
	DropdownMenuContent,
	DropdownMenuItem,
} from '#app/components/ui/dropdown-menu'
import { Icon } from '#app/components/ui/icon'
import { getUserImgSrc } from '#app/utils/misc.tsx'
import { useOptionalUser, useUser } from '#app/utils/user.ts'

export function UserProfile() {
	const user = useOptionalUser()
	return (
		<div className="mr-6 flex items-center gap-5">
			{user ? (
				<UserDropdown />
			) : (
				<Button asChild variant="default" size="lg">
					<Link to="/login" className="text-nowrap">
						Log In
					</Link>
				</Button>
			)}
		</div>
	)
}

function UserDropdown() {
	const user = useUser()
	const formRef = useRef<HTMLFormElement>(null)
	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<div>
					<Button asChild variant="secondary">
						<Link
							to={`/member/${user.username}`}
							// this is for progressive enhancement
							onClick={(e) => e.preventDefault()}
							className="flex items-center gap-2"
						>
							<img
								className="h-8 w-8 rounded-full object-cover"
								alt={user.member ?? user.username}
								src={getUserImgSrc({
									imageId: user.image?.id,
									userId: user.id,
								})}
							/>
							<span className="text-body-sm flex overflow-hidden font-bold text-nowrap text-ellipsis">
								{user.member ?? user.username}
							</span>
						</Link>
					</Button>
				</div>
			</DropdownMenuTrigger>
			<DropdownMenuPortal>
				<DropdownMenuContent sideOffset={8} align="start">
					<DropdownMenuItem asChild>
						<Link prefetch="intent" to={`/member/${user.username}/contact`}>
							<Icon className="text-body-md m-2" name="avatar">
								Profile
							</Icon>
						</Link>
					</DropdownMenuItem>
					<DropdownMenuItem asChild>
						<Link prefetch="intent" to={`/member/${user.username}/passkeys`}>
							<Icon className="text-body-md m-2" name="passkey">
								Passkeys
							</Icon>
						</Link>
					</DropdownMenuItem>
					<DropdownMenuItem asChild>
						<Link prefetch="intent" to={`/member/${user.username}/irrigation`}>
							<Icon className="text-body-md m-2" name="droplets">
								Irrigation
							</Icon>
						</Link>
					</DropdownMenuItem>
					<DropdownMenuItem asChild>
						<Link
							prefetch="intent"
							to={`/member/${user.username}/transactions`}
						>
							<Icon className="text-body-md m-2" name="reader">
								Transactions
							</Icon>
						</Link>
					</DropdownMenuItem>
					<DropdownMenuItem asChild>
						<Link
							prefetch="intent"
							to={`/member/${user.username}/notifications`}
						>
							<Icon className="text-body-md m-2" name="sms-block">
								Message Settings
							</Icon>
						</Link>
					</DropdownMenuItem>
					<Form action="/logout" method="POST" ref={formRef}>
						<DropdownMenuItem asChild>
							<button type="submit" className="w-full">
								<Icon className="text-body-md" name="exit">
									Logout
								</Icon>
							</button>
						</DropdownMenuItem>
					</Form>
				</DropdownMenuContent>
			</DropdownMenuPortal>
		</DropdownMenu>
	)
}
